import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../../../app/shared/enums/HttpStatusCodes';
import { AppSettings } from '../../app.settings';
import { TransferDataService } from '../../private/shared/services/transfer-data.service';
import { AUTENTIFICACION_ENDPOINTS, GESTION_CONTENIDO_ENDPOINTS, GETS } from '../../shared/models/Constants';
import { CrashlyticsService } from '../../shared/services/crashlytics/crashlytics.service';
import { DispatchInitService } from '../../shared/services/dispatch-init/dispatch-init.service';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import { MainAnalyticsService } from '../../shared/analytics/main-analytics/main-analytics.service';
import {
    authUserPhone,
    cancelAccount,
    clearDataUser,
    clearDataUserSuccess,
    errroAuthUserPhone,
    errroCancelAccount,
    errroGetConfig,
    errroValidatedJwtBOUser,
    errroValidatedJwtWaUser,
    getConfig,
    setUserInfoApp,
    successAuthUserPhone,
    successCancelAccount,
    successGetConfig,
    successValidatedJwtBOUser,
    successValidatedJwtWaUser,
    succesUserInfoApp,
    validatedJwtBOUser,
    validatedJwtWaUser,
} from '../actions';
import { IResultValidJwtWA } from './../../shared/models/Tenderos.interface';

@Injectable()
export class DataUserEffets {
    constructor(
        private actions$: Actions
        , private dispatchInitS: DispatchInitService
        , private transferDataS: TransferDataService
        , private crashlytics: CrashlyticsService
        , private httpS: SharedServiceService
        , private mainAnalyticsS: MainAnalyticsService
    ) { }

    /**
     * Setea idbodega con nud a store
     */
    public setUserInfoApp$ = createEffect(
        () => this.actions$.pipe(
            ofType(setUserInfoApp),
            tap(actions => {
                const userId = `${actions.ID_Bodega}-${actions.NUD}-${JSON.parse(localStorage.getItem(AppSettings.TOKEN_KEY)).uniqueDeviceID}`;
                this.crashlytics.setCrashlyticsUserId(userId);
            }),
            map(actions => succesUserInfoApp({ ...actions })),
            tap(() => this.dispatchInitS.newFechaIngreso()),
            tap(() => this.mainAnalyticsS.syncUserPropertiesToFirebase()),
        )
    );

    /**
     * * Cancelacion de cuenta
     */
    public clearDataUser$ = createEffect(
        () => this.actions$.pipe(
            ofType(clearDataUser),
            tap(() => this.dispatchInitS.callbackSendDeviceInfo()),
            tap(() => this.transferDataS.emitTemporizador(false)),
            tap(() => this.crashlytics.setCrashlyticsUserId(`00-${JSON.parse(localStorage.getItem(AppSettings.TOKEN_KEY)).uniqueDeviceID}`)),
            map(() => clearDataUserSuccess()),
        )
    );

    /**
     * * Acepta los legales
     */
    public cancelAccount$ = createEffect(
        () => this.actions$.pipe(
            ofType(cancelAccount),
            switchMap(
                () => this.httpS.executeRequestByUser(AUTENTIFICACION_ENDPOINTS.put_cancel_account, null)
                    .pipe(
                        map(resp => successCancelAccount(resp)),
                        catchError((err: Error) => of(errroCancelAccount({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Validated Jwt Wa User
     */
    public validatedJwtWaUser$ = createEffect(
        () => this.actions$.pipe(
            ofType(validatedJwtWaUser),
            switchMap(
                actions => this.httpS.executeFunctionDataUser(GETS.ValidatedJwtWaUser, actions)
                    .pipe(
                        tap<IResultValidJwtWA>(resp => this.httpS.bodegaNud$.next({ ...this.httpS.bodegaNud$.getValue(), ID_Conversacion: resp.data.ID_Conversacion })),
                        map(resp => successValidatedJwtWaUser(resp)),
                        catchError((err: Error) => of(errroValidatedJwtWaUser({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Validated Jwt BO User
     */
    public validatedJwtBOUser$ = createEffect(
        () => this.actions$.pipe(
            ofType(validatedJwtBOUser),
            switchMap(
                actions => this.httpS.executeRequestByUser(AUTENTIFICACION_ENDPOINTS.post_validate_token_bo, actions)
                    .pipe(
                        map(resp => successValidatedJwtBOUser(resp)),
                        catchError((err: Error) => of(errroValidatedJwtBOUser({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Genera un nuevo token
     */
    public authUserPhone$ = createEffect(
        () => this.actions$.pipe(
            ofType(authUserPhone),
            switchMap(
                actions => this.httpS.executeFunctionDataUser(GETS.AuthUserPhone, actions)
                    .pipe(
                        map(resp => successAuthUserPhone(resp)),
                        catchError((err: Error) => of(errroAuthUserPhone({ payload: err })))
                    )
            )
        )
    );

    /**
     * * Obtiene variable de configuracion
     */
    public getConfig$ = createEffect(
        () => this.actions$.pipe(
            ofType(getConfig),
            switchMap(
                actions => this.httpS.executeRequestByUser(GESTION_CONTENIDO_ENDPOINTS.post_get_execution_config, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.CONTENIDO))
                    .pipe(
                        map(resp => successGetConfig(resp)),
                        catchError((err: Error) => of(errroGetConfig({ payload: err })))
                    )
            )
        )
    );

}
